import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { User } from '../../models/user-model';
import { MatPaginator } from '@angular/material/paginator';
import { UserMasterService } from '../../services/user-master-service';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { UserCreatePayload } from '../../models/user-create-model';

@Component({
  selector: 'app-user-master-list',
  templateUrl: './user-master-list.component.html',
  styleUrls: ['./user-master-list.component.css'],
})
export class UserMasterListComponent implements OnInit {
  public dataSource = new MatTableDataSource<User>();
  public l_userFilteredList: User[] = [];
  public l_UserRole: string = '';

  displayedColumns: string[] = [
    'srNo',
    'fullName',
    'loginId',
    'role',
    'email',
    'phone',
    'status',
    'actions',
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private l_UserService: UserMasterService,
    private l_UtilityService: UtilityService
  ) {}

  async ngOnInit(): Promise<void> {
    this.l_UserRole = sessionStorage.getItem('role');
    await this.lFN_FetchUserList();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  lFN_EditUser(user: User): void {
    if (this.l_UserRole != 'SUPER_ADMIN' && this.l_UserRole != 'ADMIN') {
      this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins and admins can edit the user.',
        'Permission Denied'
      );
      return;
    }

    if( this.l_UserRole == 'ADMIN' && user.roleName == 'SUPER_ADMIN')
    {
        this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins can superadmin user.',
        'Permission Denied'
      );
      return;
    }

    if( this.l_UserRole == 'ADMIN' && user.roleName == 'ADMIN')
    {
        this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins can edit admin user.',
        'Permission Denied'
      );
      return;
    }


    this.l_UtilityService.lFN_NavigateViaExtras(
      'createuser',
      { userId: user.userId },
      'edit'
    );
  }

  async lFN_FetchUserList() {
    this.l_UtilityService.lFN_ShowLoader();

    let l_userListResponse = this.l_UserService.lFN_GetUserList();

    l_userListResponse.subscribe({
      next: async (data) => {
        if (data.status === 200) {
          this.dataSource.data = [];
          this.l_userFilteredList = [];

          const parsedData = JSON.parse(data.body);

          let l_list: User[] = [];
          let l_listOriginal: User[] = [];

          for (const item of parsedData.data) {
            const user = new User({
              userId: item.userId,
              fullName: item.fullName,
              loginId: item.loginId,

              email: item.emailId,
              phone: item.phoneNo,

              roleId: item.role?.roleId,
              roleName: item.role?.roleName,

              deptId: item.department?.deptId,
              deptName: item.department?.deptName,

              isActive: item.isActive === 'YES',
            });

            l_list.push(user);
            l_listOriginal.push(user);
          }

          this.dataSource.data = l_list;
          this.l_userFilteredList = l_listOriginal;
        } else if (data.status === 204) {
          this.l_UtilityService.lFN_WarningToaster(
            'User list not available',
            ''
          );
          this.dataSource.data = [];
        }

        this.l_UtilityService.lFN_HideLoader();
      },
      error: (error) => {
        console.error('Error fetching users:', error);
        this.l_UtilityService.lFN_ErrorToaster(error, 'Failed to load users');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      },
    });
  }

  lFN_ChangeUserStatus(user: User): void {
    if (this.l_UserRole != 'SUPER_ADMIN') {
      this.l_UtilityService.lFN_WarningToaster(
        'Only superadmins can change user status.',
        'Permission Denied'
      );
      return;
    }

    const newStatus = !user.isActive;
    const statusLabel = newStatus ? 'Active' : 'Inactive';

    const dialogData = {
      title: `Change User Status - ${user.loginId}`,
      message: `Are you sure you want to change status of ${user.fullName} to ${statusLabel}?`,
      buttons: [
        {
          label: 'Yes',
          value: true,
          color: 'primary',
          className: 'btn-yes-custom',
        },
        { label: 'No', value: false, color: 'warn' },
      ],
    };

    this.l_UtilityService
      .lFN_ShowConfirmationDialog(
        dialogData.title,
        dialogData.message,
        dialogData.buttons
      )
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.l_UserService.lFN_ToggleUserStatus(user.userId).subscribe({
          next: (response: any) => {
            user.isActive = newStatus;

            this.l_UtilityService.lFN_SuccessToaster(
              response?.body?.msg || 'User status updated successfully',
              'Success'
            );
          },
          error: (err) => {
            const errorMsg = err.error?.msg || 'Failed to change user status';

            this.l_UtilityService.lFN_ErrorToaster(errorMsg, 'Error');
          },
        });
      });
  }
}
